import PropTypes from 'prop-types'

// TODO: RPT-25: Check this JSDoc for validity and add descriptions!
// http://s02.sdev02.dev.ttw:8380/swagger-ui.html#!/AdminLogbook/getLogbookUsingGET

/**
 * @typedef  {Object} LogbookEntry
 * @property {string}           [tripId]
 * @property {string|string[]}  controlFlags
 * @property {string}           [startTime]
 * @property {string}           [endTime]
 * @property {Array}            [startPosition]
 * @property {Array}            [endPosition]
 * @property {string}           [startAddressId]
 * @property {string}           [endAddressId]
 * @property {number}           [startOdometer]
 * @property {number}           [endOdometer]
 * @property {string}           [tripMode]
 * @property {number}           [distance]
 * @property {string}           [purpose]
 * @property {string}           [contact]
 * @property {string}           [comment]
 * @property {string}           [lastModifyTime]
 * @property {string}           [lastModifyUserName]
 * @property {string}           [objectId]
 * @property {string}           [driverId]
 */

// TODO: RPT-25: Correct the PropType, there are more fields than 2!
// http://s02.sdev02.dev.ttw:8380/swagger-ui.html#!/AdminLogbook/getLogbookUsingGET

export const logbookEntryPropType = PropTypes.shape({
    controlFlags: PropTypes.arrayOf(PropTypes.string),
    tripId: PropTypes.string
})
